import { FC } from 'react'
import { Link } from 'react-router-dom'
import { formatDateTime } from '../../../../../../_metronic/helpers/crud-helper/helpers'
import { ModalSize } from '../../../../../../_metronic/helpers/enumsUI'
import { PageHeading } from '../../../../../components/Header/PageHeading'
import { Button } from '../../../../../components/Button/Button'
import { useModal } from '../../../../../components/Modal/ModalContext'
import { CondicaoCatalogo } from '../../../formularios/core/condicao/catalogo'
import { CriarRascunhoButton } from '../../acoes/CriarRascunhoButton'
import { AprovarProtocoloModal } from '../../aprovacao/AprovarProtocoloModal'
import { useProtocoloAcoes } from '../../core/useProtocoloAcoes'
import { useEmpresaDaTela } from '../../core/useEmpresaDaTela'
import { CLASSE_LINK_OUTLINE } from '../../core/classeLinkOutline'
import { SituacaoProtocoloBadge } from '../../components/SituacaoProtocoloBadge'
import { ProtocoloDetalhe } from '../../core/_models'

type Props = {
  versao: ProtocoloDetalhe
  catalogo?: CondicaoCatalogo
  onAprovado: () => void
}

/**
 * Cabeçalho da versão do protocolo, acima do card (mesmo formato do modelo publicado): versão e
 * nome como título; situação, origem e aprovação numa linha de apoio; ações à direita — "Aprovar"
 * é a principal no rascunho, "Criar rascunho" nas demais.
 */
export const ProtocoloDetalheHeading: FC<Props> = ({ versao, catalogo, onAprovado }) => {
  const { idEmpresa } = useEmpresaDaTela()
  const { acoes } = useProtocoloAcoes(idEmpresa)
  const { showModal } = useModal()

  const podeAprovar = versao.situacao === 'RASCUNHO' && acoes.podeAprovar

  const abrirAprovacao = () =>
    showModal({
      title: `Aprovar a versão ${versao.versao}`,
      size: ModalSize.Large,
      content: (
        <AprovarProtocoloModal protocolo={versao} catalogo={catalogo} onAprovado={onAprovado} />
      ),
    })

  const aprovacao =
    versao.dtAprovacao &&
    `Aprovado por ${[versao.aprovador?.nome, versao.crmAprovador]
      .filter(Boolean)
      .join(' — ')} em ${formatDateTime(versao.dtAprovacao)}`

  const apoio = [
    versao.modeloOrigem && `Criado a partir do modelo Lauduz v${versao.modeloOrigem.versao}`,
    versao.protocoloOrigem && `Criado a partir da versão ${versao.protocoloOrigem.versao}`,
    aprovacao,
  ].filter(Boolean)

  return (
    <PageHeading
      title={`Versão ${versao.versao} — ${versao.nome}`}
      description={
        <span className='d-inline-flex flex-wrap align-items-center gap-3'>
          <SituacaoProtocoloBadge situacao={versao.situacao} />
          {apoio.length > 0 && <span>{apoio.join(' · ')}</span>}
        </span>
      }
      actions={
        <div className='d-flex flex-wrap align-items-center gap-3'>
          <Link
            className={CLASSE_LINK_OUTLINE}
            to={`/apps/protocolos-triagem/${versao.id}/comparar?empresa=${idEmpresa}`}
          >
            Comparar versões
          </Link>
          {versao.situacao !== 'RASCUNHO' && (
            <CriarRascunhoButton
              escopo='versao'
              idEmpresa={idEmpresa}
              idOrigem={versao.id}
              podeCriarRascunho={acoes.podeCriarRascunho}
              aparencia='principal'
            />
          )}
          {podeAprovar && (
            <Button className='btn-primary' onClick={abrirAprovacao}>
              Aprovar
            </Button>
          )}
        </div>
      }
    />
  )
}
